import {
  financialFetch,
  financialPost,
  financialPut,
  financialDelete,
} from "../../../Component/function/FinancialApi";

const ENDPOINT = "CompanyCapital";

const buildQueryUrl = (base, params = {}) => {
  const cleaned = {};

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== "" &&
      value !== null &&
      value !== undefined
    ) {
      cleaned[key] = value;
    }
  });

  const query = new URLSearchParams(cleaned).toString();

  return query ? `${base}?${query}` : base;
};

const companyCapitalService = {
  getAll: async (params = {}) => {
    const url = buildQueryUrl(ENDPOINT, params);

    return await financialFetch(url);
  },

  getById: async (id) => {
    return await financialFetch(`${ENDPOINT}/${id}`);
  },

  getSummary: async () => {
    return await financialFetch(`${ENDPOINT}/Summary`);
  },

  create: async (payload) => {
    const response = await financialPost(
      ENDPOINT,
      payload
    );

    return response?.data;
  },

  update: async (id, payload) => {
    const response = await financialPut(
      `${ENDPOINT}/${id}`,
      payload
    );

    return response?.data;
  },

  remove: async (id) => {
    const response = await financialDelete(
      `${ENDPOINT}/${id}`
    );

    return response?.data;
  },
};

export default companyCapitalService;